import React, {useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';

import useColor from 'hooks/useColor';
import useOutsideAlerter from 'hooks/useOutsideAlerter';
import ModalChooseColor from 'components/Colors/ModalChooseColor';

import LogoDonDomino from 'assets/images/dondomino.png';

function ColorSelector(props) {
	let {
		active = false,
		disabled = false
	} = props;

	const wrapperRef = useRef(null);
	const {t} = useTranslation();
	const [openPalette, setOpenPalette] = useState(false);

	const [openAddPalette, setOpenAddPalette] = useState({
		open: false,
		edit: false
	});

	const openModalAddColor = () => {
		setOpenAddPalette({
			...openAddPalette,
			open: true
		});
	}
	useOutsideAlerter(wrapperRef, () => {
		setOpenPalette(false);
	});

	const onChangeComplete = (color) => {
		//setCurrent(color.hex);
		setCurrent(color);
		toogleOpenPalette();
	}

	const toogleOpenPalette = (evt) => {
		if (disabled) {
			return;
		}
		props.setActive(0);
		setOpenPalette(!openPalette);
		if (evt) {
			evt.stopPropagation();
			evt.preventDefault();
		}
	}

	const {
		palettes,
		paletteIndex,
		colors,
		color,
		setCurrent,
		setCurentPalette,
		deletePalette
	} = useColor();

	let currentPalette = false;
	if (palettes && typeof palettes[paletteIndex] !== 'undefined') {
		currentPalette = palettes[paletteIndex];
	}

	return (
		<>
			<ModalChooseColor
				forceOpen={openAddPalette.open}
				edit={openAddPalette.edit}
				setForceOpenOpen={() => {
					setOpenAddPalette({
						open: false,
						edit: false
					})
				}}
			/>
			<div
				ref={wrapperRef}
				className="wrapper-tool-colortool"
				onMouseEnter={toogleOpenPalette}
				onMouseLeave={toogleOpenPalette}
			>

				<button
					//onClick={toogleOpenPalette}
					type="button"
					className={'btntool btn btn-primary p-0 color-paint' + (active ? ' active' : '') + (disabled ? ' disabled' : '')}
				>
					<svg
						viewBox="0 0 24 24"
						width="24" height="24"
						stroke="currentColor"
						strokeWidth="2"
						fill="none"
						strokeLinecap="round"
						strokeLinejoin="round"
						className={color !== false && color.color === 'transparent' ? 'transparent' : ''}
						style={{
							fill: color !== false ? color.color : 'url(#diagonalHatch)'
						}}
					>
						<pattern id="diagonalHatch" patternUnits="userSpaceOnUse" width="4" height="4">
							<path d="M-1,1 l2,-2 M0,4 l4,-4 M3,5 l2,-2"
							      style={{
								      stroke: 'black',
								      strokeWidth: 1
							      }}
							/>
						</pattern>

						<path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>
					</svg>
				</button>
				{openPalette && (
					<div className="colors-selector">
						<div className="arrow"></div>
						<div className="input-group">
							<select
								className="form-select"
								onChange={(evt) => {
									setCurentPalette(evt.target.value);
								}}
								value={paletteIndex}
							>
								{palettes.map((pl, indexPalette) => {
									return (
										<option value={indexPalette} key={indexPalette}>{pl.name}</option>
									)
								})}
							</select>


							{currentPalette.intern === false && (<div
								onClick={() => {
									setOpenAddPalette({
										open: true,
										edit: true
									})
								}}
							>
								<svg

									viewBox="0 0 24 24"
									width="20"
									height="20"
									stroke="currentColor"
									strokeWidth="2"
									fill="none"
									strokeLinecap="round"
									strokeLinejoin="round"
								>
									<path d="M12 20h9"></path>
									<path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path>
								</svg>
							</div>)}
							{currentPalette.intern === false && (<div
								onClick={() => {
									if (palettes.length === 1) {
										alert(t('ColorSelector.deletePaletteError'));
										return;
									}
									let affirm = window.confirm(t('ColorSelector.deletePaletteConfirm'));
									if (affirm) {
										deletePalette(palettes[paletteIndex].id);
									}
								}}
							>
								<svg viewBox="0 0 24 24" width="20" height="20" stroke="currentColor" strokeWidth="2"
								     fill="none"
								     strokeLinecap="round" strokeLinejoin="round" className="css-i6dzq1">
									<polyline points="3 6 5 6 21 6"></polyline>
									<path
										d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
								</svg>
							</div>)}
						</div>

						<div className={'parent-wrapper-colors-palette ' + currentPalette.type}>
							{currentPalette.type && currentPalette.type === 'dondomino' && (
								<a href="https://www.dondomino.eu/" target="_blank"><img src={LogoDonDomino} /></a>
							)}
							<div className="wrapper-colors-palette">
								{colors.map((colorData) => {
									return (
										<div
											title={t(colorData.color)}
											onClick={() => {
												onChangeComplete(colorData.color);
											}}
											className={colorData.color}
											key={'color' + colorData.color}
											style={{
												backgroundColor: colorData.color
											}}></div>
									)
								})}
							</div>
						</div>


						<button
							type="button"
							className="btn btn-primary mb-1"
							onClick={openModalAddColor}
						>
							{t('ColorSelector.addNewPalette')}
						</button>

					</div>
				)}
			</div>
		</>
	);
}

export default ColorSelector;
